import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Icon } from 'ui';
import { useFeatureFlags } from 'hooks';
import { Comment } from 'ui/Icon/Streamline';
import { getAskTheExpertToggleTranslations } from 'selectors/learn/meta';
import AskTheExpertToggle from '../shared/AskTheExpertToggle';

const AskTheExpert = ({ i18n, currentUser, showSimpleVersion, className }) => {
  const hasUnificationFlag = useFeatureFlags('readiness-enable-unification');
  if (!currentUser.email) return null;

  return (
    <AskTheExpertToggle i18n={i18n.expertToggle}>
      {({ toggleModal }) => (
        <div
          className={cn(
            {
              LearnAskTheExpert: !hasUnificationFlag,
              'LearnAskTheExpert-unification mt-10 ai-c fd-r':
                hasUnificationFlag,
              'mt-4': showSimpleVersion,
            },
            className,
          )}
        >
          <span>{i18n.expert.question}</span>
          <span
            className={cn('ButtonLink c-p', {
              'SelecTable-actionButton c-brand-blue': !hasUnificationFlag,
              'LearnAskTheExpert-unification': hasUnificationFlag,
            })}
            role="button"
            tabIndex="0"
            onClick={toggleModal}
            onKeyDown={e => e.key === 'Enter' && toggleModal()}
          >
            {hasUnificationFlag ? (
              <Comment className="ml-8 mr-8" />
            ) : (
              <Icon name="chat_outline" className="LearnHeader-expertIcon" />
            )}
            {i18n.expert.action_button}
          </span>
        </div>
      )}
    </AskTheExpertToggle>
  );
};

const mapStateToProps = state => ({
  i18n: {
    expert: state.meta.i18n.learn.expert,
    expertToggle: getAskTheExpertToggleTranslations(state),
  },
  currentUser: {
    email: state.meta.currentUser.email,
  },
});

export default connect(mapStateToProps)(AskTheExpert);
